const STORAGE_KEY = 'scp-cart';

export default {
  items: [],
  _hostname: '',

  init() {
    const meta = document.querySelector('meta[name="shopify-hostname"]');
    this._hostname = meta ? meta.content : '';

    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        this.items = JSON.parse(stored);
      }
    } catch {
      this.items = [];
    }
  },

  _persist() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
    } catch {
      // Storage full or unavailable
    }
  },

  add(product) {
    const existing = this.items.find((i) => i.variantId === product.variantId);

    if (existing) {
      existing.qty += 1;
      this.items = [...this.items];
    } else {
      this.items = [
        ...this.items,
        {
          variantId: product.variantId,
          title: product.title,
          price: product.price,
          imageUrl: product.imageUrl || '',
          productUrl: product.productUrl || '',
          qty: 1,
        },
      ];
    }

    this._persist();
  },

  remove(variantId) {
    this.items = this.items.filter((i) => i.variantId !== variantId);
    this._persist();
  },

  updateQty(variantId, qty) {
    const n = parseInt(qty, 10);

    if (n <= 0) {
      this.remove(variantId);
      return;
    }

    const item = this.items.find((i) => i.variantId === variantId);
    if (item) {
      item.qty = n;
      this.items = [...this.items];
      this._persist();
    }
  },

  get totalItems() {
    return this.items.reduce((sum, i) => sum + i.qty, 0);
  },

  get subtotal() {
    return this.items.reduce((sum, i) => sum + i.price * i.qty, 0);
  },

  get formattedSubtotal() {
    return '$' + this.subtotal.toFixed(2);
  },

  get isEmpty() {
    return this.items.length === 0;
  },

  get checkoutUrl() {
    if (!this._hostname || this.isEmpty) return '#';

    const lineItems = this.items.map((i) => `${i.variantId}:${i.qty}`).join(',');
    return `https://${this._hostname}/cart/${lineItems}`;
  },
};
